// extracted by mini-css-extract-plugin
export default {"button":"HorizontalSlides_button__zsY55","slide":"HorizontalSlides_slide__8f894"};